import { render } from "./RechargePricesEdit.vue?vue&type=template&id=2a814481"
import script from "./RechargePricesEdit.vue?vue&type=script&lang=js"
export * from "./RechargePricesEdit.vue?vue&type=script&lang=js"

import "./RechargePricesEdit.vue?vue&type=style&index=0&id=2a814481&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__